import * as React from 'react';
import { TextInputWithSave, TextInputWithSaveProps } from '../../inputs/TextInputWithSave';
import { FormField, formFieldValidationHelper } from '../FormField';
import { iconName } from '../../icons/Icons';

type TextSaveFieldProps = Omit<TextInputWithSaveProps, 'onSave' | 'inErrorState'> & {
    label: string,
    infoMessage?: string,
    formFieldLeadingIcon?: iconName,
    errorMessage?: string,
    hideLabel?: boolean,
    reserveLabelSpace?: boolean,
    reserveMessageSpace?: boolean,
    formFieldStyle?: React.CSSProperties,
    validator?: (currentValue: string) => { valid: true; } | { valid: false, errorMessage: string; },
    onSave: (value: string, isValid: boolean) => void;
};

export function TextSaveField (props: TextSaveFieldProps)
{
    const [currentValue, setCurrentValue] = React.useState(props.value);

    function handleChange (value: string)
    {
        setCurrentValue(value);
        if (props.onChange)
        {
            props.onChange(value);
        }
    }

    function handleCancel (cancelledValue: string, restoredValue: string)
    {
        setCurrentValue(restoredValue);
        if (props.onCancel)
        {
            props.onCancel(cancelledValue, restoredValue);
        }
    }

    function handleSave (newValue: string)
    {
        setCurrentValue(newValue);
        props.onSave(newValue, !inErrorState);
    }

    const { inErrorState, message } = formFieldValidationHelper(currentValue, props.infoMessage, props.errorMessage, props.validator);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { formFieldStyle, formFieldLeadingIcon, infoMessage, errorMessage, validator, reserveLabelSpace, ...inputProps } = props;

    return (
        <FormField
            label={props.label}
            leadingIcon={formFieldLeadingIcon}
            style={formFieldStyle}
            inputComponent={
                <TextInputWithSave
                    {...inputProps}
                    value={props.value}
                    onChange={handleChange}
                    onCancel={handleCancel}
                    onSave={handleSave}
                    onSaveNoChange={props.onSaveNoChange}
                    inErrorState={inErrorState}
                />
            }
            inErrorState={inErrorState}
            message={message}
            reserveMessageSpace={props.reserveMessageSpace ?? true}
            hideLabel={props.hideLabel}
        />
    );
}